<template>
    <section class="container">
        <div class="row services_section">
            <div class="col-md-4 section_services_item" v-for="item in servisesData" :key="item.id">
                <div class="text_services">
                    <h6>{{item.header[lang()]}}</h6>
                    <div style="padding-bottom: 5px;">
                        <img class="img_services" :src="item.image" title="yotube-strategiya">
                    </div>
                    <button class="btn services-custom-button" @click="getMoreInfo(item)">{{ storeBtn[lang()] }}</button>
                </div>
            </div>
        </div>

        <modal v-if="services_block" @off="services_block = false">
            <div class="modal_info">
                <h5>{{ servisesItem.header[lang()] }}</h5>
                <div class="row">
                    <div class="col-md-6" style="text-align: center;">
                        <img :src="servisesItem.image"
                            alt="yoda"
                            title="yoda"
                            style="width: 50%;
                                    height: auto;
                                    position: relative;
                                    border-radius: 0.2rem"
                            >
                    </div>
                    <div class="col-md-6">
                        <p>
                            {{ servisesItem.text[lang()] }}
                        </p>
                    </div>
                </div>
            </div>
        </modal>
    </section>
</template>

<script>
import modal from './modal.vue';
import { store } from '../store.js';
export default {
  data () {
    return {
      services_block: false,
      servisesItem: null
    }
  },
  components: {
    modal
  },
  methods: {
    lang() {
      return localStorage.getItem('lang');
    },
    getMoreInfo(item) {
      this.servisesItem = item;
      this.services_block = true;
    }
  },
  computed: {
    storeBtn() {
      return store.learnMoreBTN
    },
    servisesData() {
      return store.getStart.service_data;
    }
  }
}

</script>

<style>
    .services_section {
        height: calc(100vh - 10vh)
    }
    .section_services_item {
        height: 40vh;
        text-align: center;
        padding: 1.2rem;
    }
    .text_services {
        height: 35vh;
        border-radius: 0.2rem;
        padding: 0.5rem;
        position: relative;
        cursor: pointer;
        transition: .5s;
        /*border: 1px solid #d2d2d2;*/
        /*box-shadow: 1px 1px 3px 1px rgba(38, 50, 56, 0.5);*/
    }
    .text_services > h6 {
        height: 25%;
        text-transform: uppercase;
    }
    .text_services:hover {
        /*background: rgba(38, 50, 56, 0.8);*/
        background: rgba(255, 73, 122, 0.15); /* Легкий неоновий відтінок */
        box-shadow: 0 0 20px rgba(255, 73, 122, 0.3);
        transition: 0.3s;
    }
    .text_services:hover > h6 {
        color: #fff;
        z-index: 10;
    }
    .img_services {
        width: 50%;
        height: auto;
        position: relative;
        bottom: 0;
        left: 0;
        display: block;
        margin-left: 25%;
    }
    .text_services > button {
        display: none !important;
    }
    .text_services:hover > button {
        display: block !important;
        /*position: absolute;
        top: 50%;*/
        position: absolute;
        bottom: 1rem;
        width: 70%;
        left: 15%;
    }
    .modal_info > h5 {
        text-align: center;
        margin-bottom: 3rem;
    }
    @media (max-width: 767px){
        .text_services:hover {
            background: unset;
        }
        .text_services:hover > h6 {
            color:unset;
            z-index: unset;
        }
        .text_services > button {
            display: block !important;
            position: absolute;
            width: 70%;
            left: 15%;
        }
        .text_services:hover > button {
            display: unset !important;
            /*position: absolute;
            top: 50%;*/
            position: unset;
            bottom: unset;
            width: unset;
            left: unset;
        }
        .text_services:hover > button {
            display: unset !important;
            width: 70%;
        }
        .section_services_item {
            height: 50vh;
            text-align: center;
            padding: 1.2rem;
            margin-bottom: 2rem;
            border-bottom: 1px solid #d2d2d2;;
        }
        @media (orientation: landscape) {
            .section_services_item {
                height: 30vh;
            }
            .img_services {
                display: none;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Services.vue